import React from 'react';
import { Alert } from '@guildeducationinc/recess';
import { toast, ToastContent } from 'react-toastify';

interface BookmarkErrorToastProps {
	offeringId: string;
	retry?: () => Promise<void>;
}

export const BookmarkErrorToast: React.FC<BookmarkErrorToastProps> = ({ retry }) => {
	return (
		<Alert breakpoint='sm' display={true} hideClose={true} type='warning'>
			<Alert.Content>We had an issue bookmarking this program.</Alert.Content>
			<Alert.Action onClick={retry} testid='bookmark-error-toast-button'>
				Try again
			</Alert.Action>
		</Alert>
	);
};

const showToast = (content: ToastContent) => {
	const toastId = 'bookmarked';
	// Wait for the previous toast to animate out
	toast.dismiss();

	setTimeout(() => {
		toast(content, {
			toastId,
			type: 'error',
		});
	}, 0);
};

export const showErrorToast = (
	offeringId: string,
	retry?: (programId: string) => Promise<void>
) => {
	const retryAndDismiss = async () => {
		await retry(offeringId);
		toast.dismiss('bookmarked');
	};
	showToast(<BookmarkErrorToast offeringId={offeringId} retry={retryAndDismiss} />);
};
